import { useSelector } from "react-redux";
import SyllabusCard from "./SyllabusCard";

import ConfirmModal from "../../../globalComponents/ConfirmModal/ConfirmModal";

const SyllabusData = ({ userData }) => {
  const { syllabusData } = useSelector((state) => state.syllabusPagination);
  const { openConfirmModal } = useSelector((state) => state.syllabusModal);

  const tableHead = ["Proqram", "Sillabus", ""];

  console.log(syllabusData, "syllabus dataaaaaaaaaaaaaaa");

  return (
    <>
      {openConfirmModal && <ConfirmModal type="syllabus" />}

      <table className="details-table syllabus-table">
        <thead>
          <tr>
            {tableHead.map((head, i) => (
              <th key={i}>{head}</th>
            ))}
          </tr>
        </thead>

        <tbody>
          {syllabusData?.map((teacher, i) => (
            <SyllabusCard
              key={i}
              data={teacher}
              mode="desktop"
              syllabus={userData}
              cellNumber={i + 1}
            />
          ))}
        </tbody>
      </table>

      <div className="details-list-tablet syllabus-tablet">
        {syllabusData?.map((teacher, i) => (
          <SyllabusCard
            key={i}
            data={teacher}
            syllabus={userData}
            mode="tablet"
            cellNumber={i + 1}
          />
        ))}
      </div>
    </>
  );
};

export default SyllabusData;
